import { DotPill, type Tone } from "../delivery/atoms"
import { effectiveOrderStatus, orderStatusUi } from "../../utils/order-status-ui"

/** Order status → dot colour (canvas OrdB_*: ok = green, in progress = amber, stopped = red). */
const STATUS_TONE: Record<string, Tone> = {
  DRAFT: "grey",
  REGISTERED: "blue",
  REVIEWED: "amber",
  APPROVED: "green",
  AUTHORIZED: "green",
  PREPARING: "amber",
  DELIVERING: "amber",
  DELIVERED: "green",
  CLOSED: "green",
  REVIEW_REJECTED: "red",
  CANCELED: "red",
  AUTO_CANCELED: "red",
  REJECTED: "red",
}

export const orderStatusTone = (status?: string | null): Tone => STATUS_TONE[String(status ?? "").toUpperCase()] ?? "grey"

/**
 * Buyer-side order status as a DotPill. The status is the effective one (a confirmed
 * order whose delivery note is moving reads «Бэлтгэж буй» / «Хүргэж буй» / «Хүргэгдсэн»).
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function OrderStatusPill({ order }: Readonly<{ order: any }>) {
  const status = effectiveOrderStatus(order)
  return <DotPill tone={orderStatusTone(status)}>{orderStatusUi(status).label}</DotPill>
}
